module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAR5JREFUOE+tlE0SgjAMhRMc9ULsqRfS8QTaEzB4IXDPhcSROKmkP0CxOHbZ0q8vLy8g/HnhGl5ePlV73jZLd5KAefW4AuDFgUgDYgEEyuz1eJCH0oGIRXvcHSwcoYEXash6xXA+Y3YasHwqyKgWJRbao4HwWXvaGVYa0C95KC9QSqCSgYGaDV2Mb2MokG5P++tXhT5MTM9vXT0H/apwDiZdnkI7EtWzHi7BGMp5NE361Niw4qjC0Gy6f3KWmTBz2Q5G2uayz5rZHLoADx9zeHlJgC3BNWE8Nbbk9DLjsKDLedUReO33X/bLlHjE5tkolAti7K8wqzAGXKNMRDgPObDcyWHIf4GFHnK2ZLQSurno4cSzIXOxS0v7SX+bNeA3fzzZFeJHGXsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_pubType.png
// module id = POwD
// module chunks = 1